import React from "react";
import { Fade, Paper, Stack, styled } from '@mui/material';
import { If } from "./If";

export interface Statistics {
    min?: number
    max?: number
    mean?: number
    std?: number
    [key: string]: number | undefined;
}

// interfaces
export interface Props {
    state: boolean
    hucId: string
    // metadata: MetadataRecord
}

export const Heading = styled('div')(({
    theme
}) => ({
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
    paddingBottom: '0px'
}));

export const Item = styled(Paper)(({
    theme
}) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary
}));


export const MetadataItem = (props: Props & Statistics) => {
    const { state, hucId, ...stats } = props;

    return <If open={state}>
        <Fade in={state} timeout={150}>
            <Stack direction="row" spacing={1}>
                {
                    Object.keys(stats).map((item, idx) => {
                        const stat = stats[item]

                        return < React.Fragment key={idx} >
                            <div>
                                <Heading>{item}</Heading>
                                <Item>{stat ?? "NA"}</Item>
                            </div>
                        </React.Fragment>
                    })
                }
            </Stack>
        </Fade>
    </If >
}

export default MetadataItem;
